import { ADMIN_BASE_PATH } from '~/impact-measurement/constants';

export const URLS = {
  campaignAdmin: (campaignId: CampaignId) =>
    `${ADMIN_BASE_PATH}/campaigns/${campaignId}`
};
